var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.332,
    height: 35.087,
    viewBox: "0 0 41.332 35.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 170",
    d: "M33.709,66.866H30.967V41.743H42.52l-4.894,7.765a.843.843,0,0,0,1.426.9L43.3,43.672l4.244,6.735a.843.843,0,0,0,1.426-.9l-4.893-7.765h.062a1.306,1.306,0,1,0,0-2.613h-9.61a4.276,4.276,0,0,0-2.281-1.671,2.974,2.974,0,0,0-5.924,0,4.276,4.276,0,0,0-2.281,1.671h-9.61a1.306,1.306,0,1,0,0,2.613h.062L9.6,49.508a.843.843,0,0,0,1.426.9l4.244-6.735,4.244,6.735a.843.843,0,0,0,1.426-.9l-4.894-7.765H27.6V66.866H24.855a2.971,2.971,0,0,0-2.971,2.971H36.679A2.971,2.971,0,0,0,33.709,66.866Z",
    transform: "translate(-8.616 -34.75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 171",
    d: "M12.852,223.359H.449a.449.449,0,0,0-.449.449,6.651,6.651,0,0,0,13.3,0A.449.449,0,0,0,12.852,223.359Z",
    transform: "translate(0 -206.412)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 172",
    d: "M324.817,223.359h-12.4a.449.449,0,0,0-.449.449,6.651,6.651,0,0,0,13.3,0A.449.449,0,0,0,324.817,223.359Z",
    transform: "translate(-283.935 -206.412)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.5d61cd72.svg";
export { ForwardRef as ReactComponent };